// Helper para obtener la imagen del cinturón según el nombre
export const getBeltImage = (beltName) => {
  if (!beltName) return null;
  
  const beltMap = {
    'Blanco': 'blanco.png',
    'Blanco Punta Amarilla': 'blanco-punta-amarilla.png',
    'Amarillo': 'amarillo.png',
    'Amarillo Punta Verde': 'amarillo-punta-verde.png',
    'Verde': 'verde.png',
    'Verde Punta Azul': 'verde-punta-azul.png',
    'Azul': 'azul.png',
    'Azul Punta Roja': 'azul-punta-roja.png',
    'Rojo': 'rojo.png',
    'Rojo Punta Negra': 'rojo-punta-negra.png',
    'Negro 1° Dan': 'negro-1dan.png',
    'Negro 2° Dan': 'negro-2dan.png',
    'Negro 3° Dan': 'negro-3dan.png',
    'Negro 4° Dan': 'negro-4dan.png',
    'Negro 5° Dan': 'negro-5dan.png',
    'Negro 6° Dan': 'negro-6dan.png',
    'Negro 7° Dan': 'negro-7dan.png',
    'Negro 8° Dan': 'negro-8dan.png',
    'Negro 9° Dan - Gran Maestro': 'negro-9dan.png'
  };
  
  const fileName = beltMap[beltName];
  return fileName ? `/assets/belts/${fileName}` : null;
};

// Helper para obtener el color de fondo del cinturón
export const getBeltColor = (belt) => {
  if (!belt) return '#f0f0f0';
  
  // Cinturones con punta
  if (belt === 'Blanco Punta Amarilla') return 'linear-gradient(135deg, #f0f0f0 0%, #ffd700 100%)';
  if (belt === 'Amarillo Punta Verde') return 'linear-gradient(135deg, #ffd700 0%, #2e7d32 100%)';
  if (belt === 'Verde Punta Azul') return 'linear-gradient(135deg, #2e7d32 0%, #0d47a1 100%)';
  if (belt === 'Azul Punta Roja') return 'linear-gradient(135deg, #0d47a1 0%, #c62828 100%)';
  if (belt === 'Rojo Punta Negra') return 'linear-gradient(135deg, #c62828 0%, #000 100%)';
  
  // Cinturones sólidos
  if (belt.includes('Blanco')) return '#f0f0f0';
  if (belt.includes('Amarillo')) return '#ffd700';
  if (belt.includes('Verde')) return '#2e7d32';
  if (belt.includes('Azul')) return '#0d47a1';
  if (belt.includes('Rojo')) return '#c62828';
  if (belt.includes('Negro')) return '#1a1a1a';
  
  return '#f0f0f0';
};
